/** WORKSHEET_HEADER_ROW_ID constant  */
export const WORKSHEET_HEADER_ROW_ID = 1;
/** WORKSHEET_COLUMN_HEADERS_ROW_ID constant  */
export const WORKSHEET_COLUMN_HEADERS_ROW_ID = 2;
/** WORKSHEET_CONTENT_ROW_ID constant  */
export const WORKSHEET_CONTENT_ROW_ID = 3;
/** WORKSHEET_COLUMN_WIDTH constant  */
export const WORKSHEET_COLUMN_WIDTH = 12;
/** WORKSHEET_CELL_LEFT_INDENT constant  */
export const WORKSHEET_CELL_LEFT_INDENT = 1;

/** WORKSHEET_HEADER_STYLES constant  */
export const WORKSHEET_HEADER_STYLES = {
	alignment: {
		vertical: 'middle',
		horizontal: 'center',
		shrinkToFit: true,
	},
	font: {
		name: 'Calibri',
		family: 2,
		color: {argb: 'FFFFFFFF'},
		size: 18,
	},
	fill: {
		type: 'pattern',
		pattern: 'solid',
		fgColor: {argb: 'FF42424A'},
	},
};

/** WORKSHEET_SUB_HEADER_STYLES constant  */
export const WORKSHEET_SUB_HEADER_STYLES = {
	alignment: {
		vertical: 'middle',
		horizontal: 'center',
		shrinkToFit: true,
	},
	font: {
		name: 'Calibri',
		family: 2,
		color: {argb: 'FFFFFFFF'},
		size: 18,
	},
	fill: {
		type: 'pattern',
		pattern: 'solid',
		fgColor: {argb: 'FF3e5c76'},
	},
};

/** WORKSHEET_COLUMN_HEADERS_STYLES constant  */
export const WORKSHEET_COLUMN_HEADERS_STYLES = {
	alignment: {
		vertical: 'middle',
		horizontal: 'center',
		wrapText: true,
		// cell.shrinkToFit = true;
	},
	font: {
		color: {argb: 'FFFFFFFF'},
		size: 10,
	},
	fill: {
		type: 'pattern',
		pattern: 'solid',
		fgColor: {argb: 'FF999999'},
	},
};

/** WORKSHEET_TOTAL_CELL_STYLES constant  */
export const WORKSHEET_TOTAL_CELL_STYLES = {
	font: {
		name: 'Calibri',
		family: 2,
		bold: true,
	},
	fill: {
		type: 'pattern',
		pattern: 'solid',
		fgColor: {argb: 'FFCCCCCC'},
	},
};
